<template>
  <div class="modal_documentation">

    <VueMarkdown class="documentation">
      {{documentation}}
    </VueMarkdown>

    <div class="text-center">
      <button
        type="submit"
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </button>
    </div>
  </div>

</template>
<script>

import VueMarkdown from 'vue-markdown'

export default {
  props: ['documentation'],

  components:{
    VueMarkdown
  },


  methods: {
    cancel () {
      this.$emit('close')
    },
  }
}

</script>

<style lang='scss'>
  .modal_documentation{
    padding: 10px;
  }
  .documentation{
    max-height: 700px;
    overflow-y: scroll;
    &::-webkit-scrollbar{
      width: 10px;
    }
  }
</style>
